import React from "react";
import { Phone, Mail } from "lucide-react";
import { contactInfo } from "../mock";
import WaveDivider from "./WaveDivider";
import MessageForm from "./MessageForm";
import { useLanguage } from "../contexts/LanguageContext";

const Contact = () => {
  const { t } = useLanguage();
  const { prefix, highlight, suffix } = t.contact.titleParts;

  return (
    <section className="mag-contact" id="contact">
      <WaveDivider position="top" color="#ffffff" flip={true} />
      <div
        className="mag-contact-bg"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/11085913/pexels-photo-11085913.jpeg')"
        }}
      />
      <div className="mag-contact-inner">
        <h2 className="reveal" style={{ color: "#ea6161" }}>
          {prefix}
          <span style={{ color: "#ea6161" }}>{highlight}</span>
          {suffix}
        </h2>
        <div className="mag-underline-red" style={{ marginTop: 12 }} />
        <div className="mag-contact-items" id="contact-cards">
          <div className="mag-contact-item reveal">
            <div className="mag-contact-icon">
              <Phone size={26} />
            </div>
            <div className="mag-contact-item-label">{t.contact.phoneLabel}</div>
            <div className="mag-contact-item-value">
              {contactInfo.phones.map((p) => (
                <a key={p} href={`tel:${p.replace(/\s+/g, "")}`}>
                  {p}
                </a>
              ))}
            </div>
          </div>
          <div className="mag-contact-item reveal">
            <div className="mag-contact-icon">
              <Mail size={26} />
            </div>
            <div className="mag-contact-item-label">{t.contact.emailLabel}</div>
            <div className="mag-contact-item-value">
              <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
            </div>
          </div>
        </div>

        <div className="mag-form-wrap reveal">
          <MessageForm />
        </div>
      </div>
    </section>
  );
};

export default Contact;
